import api from './api';

const basePath = '/calendario/eventos';

export const calendarioService = {
    // Obtener todos los eventos disponibles para el usuario actual
    getEventos: async () => {
        try {
            const response = await api.get(basePath);
            return response.data;
        } catch (error) {
            console.error('Error obteniendo eventos:', error);
            throw error;
        }
    },

    // Crear un nuevo evento
    crearEvento: async (eventoData) => {
        try {
            const response = await api.post(basePath, eventoData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            console.error('Error creando evento:', error);
            throw error;
        }
    },

    // Actualizar un evento existente
    actualizarEvento: async (id, eventoData) => {
        try {
            const response = await api.put(`${basePath}/${id}`, eventoData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            console.error(`Error actualizando evento ${id}:`, error);
            throw error;
        }
    },

    // Eliminar un evento (borrado lógico)
    eliminarEvento: async (id) => {
        try {
            const response = await api.delete(`${basePath}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error eliminando evento ${id}:`, error);
            throw error;
        }
    },

    // Obtener el próximo evento público sin necesidad de estar logeado
    obtenerProximosEventosPublicos: async () => {
        try {
            const response = await api.get('/calendario/publico/proximos');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo próximos eventos públicos:', error);
            throw error;
        }
    }
};

export default calendarioService;
